'use client'

import { lazy, Suspense } from 'react'

// Three.js (~540KB) stays out of the page's hydration bundle — React.lazy
// loads the wave in its own chunk, so the rest of the page hydrates without
// waiting on it. The dots fly in from off-screen, so the late start is
// invisible.
const HeroEffect = lazy(() => import('./hero-effect').then((m) => ({ default: m.HeroEffect })))

/** Lazy hero wave; `peak` lifts the crest on the right (English hero). */
export function HeroWave({ peak = false }: { peak?: boolean }) {
  return (
    <Suspense fallback={null}>
      <HeroEffect peak={peak} />
    </Suspense>
  )
}
